import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";

import { isSSN } from "../../../services/utils";
import { extractDOBFromSSN, formatFullName } from "../../../services/pepWatchUtils";
import { fetchPersonBySSN } from "./PepWatchApi";
import { IPepWatchFormValues } from "../../../types/PepTypes";
import Bugsnag from "@bugsnag/js";

export const FormObserver: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<IPepWatchFormValues>();
  const [lastCheckedSSN, setLastCheckedSSN] = useState<string>("");

  useEffect(() => {
    const handleSSNChange = async () => {
      const ssn = values.ssn;

      if (ssn === lastCheckedSSN || !isSSN(ssn)) {
        return;
      }

      setLastCheckedSSN(ssn);

      if (isSSN(ssn) && !values.foreign) {
        try {
          const parsedFieldData = await fetchPersonBySSN(ssn);
          if (parsedFieldData?.firstName || parsedFieldData?.lastName || parsedFieldData?.middleName) {
            setFieldValue("name", formatFullName(parsedFieldData));
            setFieldValue("dateOfBirth", extractDOBFromSSN(ssn));
            setFieldValue("countryCode", parsedFieldData.rikisfang);
          }
        } catch (e) {
          if (e instanceof Error) Bugsnag.notify(e);
        }
      }
    };

    handleSSNChange();
  }, [values.ssn, values.foreign, lastCheckedSSN, setFieldValue]);

  return null;
};
